import AudioController from '@kids/lib/class/AudioController';
import * as sfx from '../assets/sfx'; // eslint-disable-line

AudioController.setFormats('mp3');

const audioController = new AudioController('global');
audioController.loadManifest(
    Object.entries(sfx).map(entry => ({id: entry[0], path: entry[1].replace('.mp3', '')}))
);

export default audioController;
